import clsx from 'clsx'
import InputMask from 'react-input-mask'
import {MAX_TEXT_LIMIT} from 'constants'
import {INPUT_TYPES} from 'constants'
import PhoneInput from 'react-phone-input-2'
import {useState} from 'react'
import {KTSVG} from 'helpers'
import CurrencyInput from 'react-currency-input-field'

const Input = ({
  label,
  type = INPUT_TYPES.text,
  touched,
  error,
  maxLength = MAX_TEXT_LIMIT,
  className = '',
  allowNegativeValue = false,
  decimalsLimit = 2,
  rightAlignAmount = true,
  ...rest
}) => {
  const [show, setShow] = useState(false)

  const toggleShow = () => setShow(!show)

  const inputClassName = clsx(
    `form-control form-control-lg form-control-solid${type === INPUT_TYPES.amount && rightAlignAmount ? ' text-align-end' : ''} ${className}`,
    {'is-invalid': touched && error},
    {
      'is-valid': touched && !error,
    }
  )

  const props = {
    ...rest,
    className: inputClassName,
    autoComplete: 'off',
  }

  const phoneProps = {
    ...rest,
    country: 'pk',
    inputClass: inputClassName,
    // countryCodeEditable: false,
    inputProps: {
      name: rest.name,
      autoComplete: 'off',
    },
    // isValid: (inputNumber, country) => {
    //   return inputNumber.length === (country.format.match(/\./g) || []).length
    // },
  }

  return (
    <>
      {label && <label className='form-label fs-6 fw-bolder text-dark'>{label}</label>}

      {type === INPUT_TYPES.phone ? (
        <PhoneInput {...phoneProps} />
      ) : type === INPUT_TYPES.cnic ? (
        <InputMask mask='99999-9999999-9' {...props}>
          {(inputProps) => <input {...inputProps} />}
        </InputMask>
      ) : type === INPUT_TYPES.password ? (
        <div className='form-password-input'>
          <input
            type={show ? INPUT_TYPES.text : INPUT_TYPES.password}
            {...props}
            maxLength={maxLength}
          />

          <span
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm password-toggle-button'
            onClick={toggleShow}
          >
            <KTSVG
              path={
                show
                  ? '/media/icons/duotune/art/eye-slashed.svg'
                  : '/media/icons/duotune/art/eye.svg'
              }
              className='svg-icon-3'
            />
          </span>
        </div>
      ) : type === INPUT_TYPES.textArea ? (
        <textarea {...props} maxLength={maxLength} rows={3} />
      ) : type === INPUT_TYPES.amount ? (
        <CurrencyInput
          {...props}
          maxLength={maxLength}
          decimalsLimit={decimalsLimit}
          allowNegativeValue={allowNegativeValue}
          onChange={undefined}
        />
      ) : (
        <input type={type} {...props} maxLength={maxLength} />
      )}

      {touched && error && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>{error}</div>
        </div>
      )}
    </>
  )
}

export default Input
